import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  AddressRequest,
  AddressResponse,
  RegisterRequestActivityLevelEnum,
  RegisterRequestDietGoalEnum,
  RegisterRequestGenderEnum,
} from "../openapi/client";
import { AlertColor } from "@mui/material";

export type FlowType = 'join' | 'find-best-plan';

export interface SelectionState {
  currentIndex: number;
  currentFlow?: FlowType;
  alert: IAlert;
  phoneNumber?: string;
  password?: string;
  fullName?: string;
  address?: any;
  gender?: RegisterRequestGenderEnum;
  birthDate?: string;
  height?: number;
  weight?: number;
  targetWeight?: number;
  otpVerificationCode?: string;
  allergens?: Set<string>;
  customAllergens?: Set<string>;
  allergensCombined?: Set<string>;
  medicalConditions?: Array<string>;
  customMedicalConditions?: Array<string>;
  medicalConditionsCombined?: Set<string>;
  dislikes?: Array<string>;
  customDislikes?: Array<string>;
  dislikesCombined?: Array<string>;
  dietGoal?: RegisterRequestDietGoalEnum;
  activityLevel?: RegisterRequestActivityLevelEnum;
  dietCenters?: Array<string>;
  customDietCenters?: Array<string>;
  dietCentersCombined?: Array<string>;
}

export interface IAlert {
  show: boolean;
  title?: string;
  text?: string;
  severity?: AlertColor;
}

const initialState: SelectionState = {
  currentIndex: 0,
  currentFlow: undefined,
  alert: { show: false, title: "", text: "" },
  phoneNumber: undefined,
  password: undefined,
  fullName: undefined,
  address: { zone: undefined, detail: undefined, street: undefined, building: undefined, flat: undefined },
  gender: undefined,
  birthDate: undefined,
  height: undefined,
  weight: undefined,
  targetWeight: undefined,
  otpVerificationCode: undefined,
  allergens: undefined,
  customAllergens: undefined,
  allergensCombined: undefined,
  medicalConditionsCombined: undefined,
  dietCenters: undefined,
  customDietCenters: undefined,
  dietCentersCombined: undefined,
  dietGoal: undefined,
  activityLevel: undefined,
};

export const selectionSlice = createSlice({
  name: "selection",
  initialState,
  reducers: {
    setSelection: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        alert: { show: false, title: "", text: "" },
        ...action.payload,
      };
    },
    resetSelection: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
    setIndex: (state, action: PayloadAction<any>) => {
      state.currentIndex = action.payload;
    },
    resetIndex: (state) => {
      state.currentIndex = 0;
    },
    setAlert: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        alert: action.payload,
      };
    },
    resetAlert: (state) => {
      return {
        ...state,
        alert: { show: false, title: "", text: "" },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelection, resetSelection, setIndex, resetIndex, setAlert, resetAlert } = selectionSlice.actions;

export default selectionSlice.reducer;
